'use client';

import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { Spacing } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

const SheetCloseIndicator = forwardRef<any>(({ ...rest }, ref) => {
  return (
    <Wrapper {...rest}>
      <Indicator ref={ref} />
    </Wrapper>
  );
});

const Indicator = styled(motion.div)`
  background-color: ${cssVar(theme.grey5)};
  width: 80px;
  height: 4px;
  border-radius: var(${theme.radius.sm});
  position: relative;
  margin-inline: auto;
`;

const Wrapper = styled(motion.div)`
  padding: ${Spacing.x4}rem;
  background-color: ${cssVar(theme.card)};
`;

export default SheetCloseIndicator;
